import React, { useState } from 'react';
import {
  Button, Col, FormFeedback, FormGroup, 
  Input, Label, Row, Container, Card
} from 'reactstrap';

function AddUserFormPopup(props) {
  const [errors, setErrors] = useState({});
  const [state, setState] = useState({
    companyName: props.AccountName,
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    password: '',
    confirmPassword: '',
    AccountDetailsId:props.AccountDetailsId,
    Roles:'',
  });
  
  const handleChange = e => {
    const { id, value } = e.target;
  
    setState(prev => ({ ...prev, [id]: value }));
  
    // Live validation logic
    setErrors(prevErrors => {
      const newErrors = { ...prevErrors };
  
      switch (id) {
        case 'email':
          if (!value) newErrors.email = 'Email is required.';
          else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
            newErrors.email = 'Invalid email format.';
          } else {
            delete newErrors.email;
          }
          break;
  
          case 'phoneNumber':
              if (value && !/^\d{10}$/.test(value)) {
                newErrors.phoneNumber = 'Phone number must be exactly 10 digits and contain only numbers.';
              } else {
                delete newErrors.phoneNumber;
              }
              break;


          
  
        case 'password':
        case 'confirmPassword':
          const password = id === 'password' ? value : state.password;
          const confirmPassword = id === 'confirmPassword' ? value : state.confirmPassword;
          if (password !== confirmPassword) {
            newErrors.confirmPassword = 'Passwords do not match.';
          } else {
            delete newErrors.confirmPassword;
          }
          break;
  
        default:
          if (!value) newErrors[id] = `${id.charAt(0).toUpperCase() + id.slice(1)} is required.`;
          else delete newErrors[id];
      }
  
      return newErrors;
    });
  };
  

  const isInvalid = () => {
    const requiredFields = ['firstName', 'lastName', 'email', 'password', 'role'];
    const hasEmptyFields = requiredFields.some(field => {
      const value = state[field];
      return !value || value.trim() === '';
    });
  
    const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(state.email);
    const phoneValid = !state.phoneNumber || /^\d+$/.test(state.phoneNumber);
    const passwordsMatch = state.password === state.confirmPassword;
  
    return hasEmptyFields || !emailValid || !phoneValid || !passwordsMatch;
  };
  
  

  // const handleSubmit = e => {
  //   e.preventDefault();
  //   onSubmit(state); // Handle submission in parent component
  // };
  const handleSubmit = (e) => {
    e.preventDefault();
    props.onSubmit(state);
    // closeModal(); 
  };
  
  
  return (
    <Container fluid>
      <Card className="card-of-problemarea p-4 mt-3">
       
        
        <Row form>
          
          <Col md={6}>
            <FormGroup>
              <Label for="companyName">Account Name</Label>
              <Input
                id="companyName"
                type="text"
                value={state.companyName}
                onChange={handleChange}
                disabled
               
              />
            </FormGroup>
          </Col>
          <Col md={6}>
          <FormGroup>
              <Label for="password">Role <span className="text-danger">*</span></Label>
              <select
                            id="role"
                              type="role"
                            className="form-control"
                            onChange={ handleChange} // Update role selection
                        >
                            <option value="">Select Role</option>
                            {props.memberRoles &&
                                props.memberRoles.map((role) => (
                                    <option key={role.id} value={role.id}>
                                        {role.role}
                                    </option>
                                ))}
                        </select>
            </FormGroup></Col>

          
          <Col md={6}>
            <FormGroup>
              <Label for="firstName">First Name <span className="text-danger">*</span></Label>
              <Input
                id="firstName"
                type="text"
                value={state.firstName}
                onChange={handleChange}
                required
              />
            </FormGroup>
          </Col>

          
          <Col md={6}>
            <FormGroup>
              <Label for="lastName">Last Name <span className="text-danger">*</span></Label>
              <Input
                id="lastName"
                type="text"
                value={state.lastName}
                onChange={handleChange}
                required
              />
            </FormGroup>
          </Col>

          
          <Col md={6}>
            <FormGroup>
              <Label for="email">Email <span className="text-danger">*</span></Label>
              <Input
                id="email"
                type="email"
                value={state.email}
                onChange={handleChange}
                required
              />
              {errors.email && <span style={{ color: 'red' }} className="text-red-500">{errors.email}</span>}
            </FormGroup>
          </Col>

          <Col md={6}>
            <FormGroup>
              <Label for="phoneNumber">Phone Number</Label>
              <Input
                id="phoneNumber"
                type="tel"
                value={state.phoneNumber}
                onChange={handleChange}
                required
              />
              {errors.phoneNumber && <span style={{ color: 'red' }} className="text-red-500">{errors.phoneNumber}</span>}
            </FormGroup>
          </Col>
        
          <Col md={6}>
            <FormGroup>
              <Label for="password">Password <span className="text-danger">*</span></Label>
              <Input
                id="password"
                type="password"
                value={state.password}
                onChange={handleChange}
                required
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label for="confirmPassword">Confirm Password <span className="text-danger">*</span></Label>
              <Input
                id="confirmPassword"
                type="password"
                value={state.confirmPassword}
                onChange={handleChange}
                invalid={state.password && state.password !== state.confirmPassword}
                required
              />
              {errors.confirmPassword && <span style={{ color: 'red' }} className="text-red-500">{errors.confirmPassword}</span>}

              {/* <FormFeedback>Passwords must match</FormFeedback> */}
            </FormGroup>
          </Col>
          
          <Col md={12} className="text-center mt-4">
            <Button
              color="primary"
              className="btn-wide btn-pill btn-shadow btn-hover-shine"
              onClick={handleSubmit}
              disabled={isInvalid()}
              size="lg"
            >
              Add User
            </Button>
          </Col>
        </Row>
      </Card>
    </Container>
  );
}

export default AddUserFormPopup;

